import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable, throwError} from 'rxjs';
import {InfoLinks} from '../../shared/models/info.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class InfoService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getInfoLinks(): Observable<InfoLinks> {
    const apartmentId = this.hoomvipStorage.getApartment();
    if (apartmentId === null) {
      return throwError(() => new Error('Apartment ID is required'));
    }
    const url = this.apiConfigService.getInfoUrl(apartmentId);
    const key = `InfoService:GET:${url}`;

    return this.cache.getOrSet<InfoLinks>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<InfoLinks>(url)
    );
  }
}
